import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStethoscope, faFlask, faXRay, faBed, faCut, faSearch } from '@fortawesome/free-solid-svg-icons';
import DoctorConversationsPanel from './DoctorConversationsPanel';
import { useAuth } from '../../hooks/useAuth';

const navItems = [
    { key: 'all-visits', label: 'All Visits', icon: faStethoscope, statKey: 'visitCountToday', path: '/patient-visits' },
    { key: 'labs', label: 'Lab Requests', icon: faFlask, statKey: 'pendingLabs', path: '/lab-requests' },
    { key: 'radiology', label: 'Radiology', icon: faXRay, statKey: 'pendingRadiology', path: '/radiology-requests' },
    { key: 'admissions', label: 'Admissions', icon: faBed, statKey: 'activeAdmissions', path: '/admissions-dashboard' },
    { key: 'surgeries', label: 'Surgeries', icon: faCut, path: '/procedures' },
    { key: 'search', label: 'Patient Search', icon: faSearch, path: '/patients' },
];

const DoctorNavPanel = ({ activeView, onNavClick, stats = {} }) => {
    const { rolePermissions } = useAuth();

    return (
        <nav className="doctor-nav-panel">
            <div className="nav-header">
                <h3>Doctor Menu</h3>
            </div>
            <div className="doctor-nav-scroll">
            {navItems.map(item => {
                // Permission gate: check if doctor has view access to the linked path
                if (item.path && rolePermissions[item.path]?.View !== 'true') {
                    return null;
                }

                const badgeCount = item.statKey ? stats[item.statKey] : null;

                return (
                    <button
                        key={item.key}
                        className={`doctor-nav-item ${activeView === item.key ? 'active' : ''}`}
                        onClick={() => onNavClick(item.key, item.path)}
                    >
                        <span className="nav-icon">
                            <FontAwesomeIcon icon={item.icon} />
                        </span>
                        {item.label}
                        {badgeCount > 0 && (
                            <span className={`nav-badge ${item.key === 'admissions' ? 'warning' : ''}`}>
                                {badgeCount}
                            </span>
                        )}
                    </button>
                );
            })}
            </div>
            <DoctorConversationsPanel />
        </nav>
    );
};

export default DoctorNavPanel;
